export default "__VITE_ASSET__zORG$Ltn__"